module.exports = __webpack_public_path__ + "img/Beach.5da3f1b5.jpg";